export default "<h1>Acceso Denegado!</h1>"